module.exports = __webpack_public_path__ + "img/dislike-icon.0e4d9b73.png";